module.exports = __webpack_public_path__ + "img/no_visitors.b33bf018.svg";